import { getFileAsset } from "@sanity/asset-utils";
import { sanityClient } from "./client";

type SanityFileSource = {
  asset?: { _ref?: string };
};

/**
 * CDN URL for an uploaded Sanity file asset (audio, video).
 *
 * The image equivalent is `urlFor`; files have no transform pipeline, so this
 * resolves the reference to a plain URL. Returns undefined rather than
 * throwing when the reference is missing or malformed, so a half-filled block
 * renders nothing instead of failing the page.
 */
function getSanityFileUrl(source: SanityFileSource | undefined) {
  if (!source?.asset?._ref) {
    return undefined;
  }

  const { dataset, projectId } = sanityClient.config();

  if (!dataset || !projectId) {
    return undefined;
  }

  try {
    return getFileAsset(source.asset._ref, { dataset, projectId }).url;
  } catch {
    return undefined;
  }
}

export { getSanityFileUrl };
